import React from "react"
import styled from "styled-components"

export default function CoolBox({ chance, investment }) {
  return (
    <Wrapper className="CoolBox">
      <TopWrapper>
        <TitleWrapper>
          <h2>賺錢機會 :</h2>
          <h1>{chance}</h1>
        </TitleWrapper>
      </TopWrapper>
      <BottomWrapper>
        <BottomTitle>適合投資物品</BottomTitle>
        <BottomContent>
          <p>{investment}</p>
        </BottomContent>
      </BottomWrapper>
    </Wrapper>
  )
}
const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: end;
  * {
    margin: 0;
  }
  gap: 30px;
`
const TopWrapper = styled.div`
  position: relative;

  gap: 10px;
  width: 100%;
  padding: 30px 30px 60px 30px;
  border: 1px solid #00fff0;
  border-radius: 12px;
  background: linear-gradient(
    135deg,
    rgba(0, 255, 238, 0.264),
    rgba(0, 255, 238, 0)
  );
  clip-path: polygon(
    0 0,
    100% 0,
    100% 100%,
    60% 100%,
    calc(60% - 32px) calc(100% - 32px),
    0% calc(100% - 32px)
  );
  &:before {
    content: "";
    position: absolute;
    width: calc(60% - 32px);
    background-color: #00fff0;
    bottom: 32px;
    left: 0;
    height: 1px;
  }
  &:after {
    content: "";
    position: absolute;
    width: 90px;
    background-color: #00fff0;
    bottom: 0px;
    left: 60%;
    height: 1px;
    transform: translate(-50%, -50%) rotate(45deg);
  }
`

const TitleWrapper = styled.div`
  width: 100%;
  display: flex;
  position: relative;
  justify-content: space-between;
  h2 {
    font-size: 24px;
    color: #00fff0;
    @media (max-width: 768px) {
      font-size: 24px;
    }
  }
  h1 {
    position: absolute;
    right: 0;
    top: -4px;
    font-size: 48px;
    color: #00fff0;
    @media (max-width: 768px) {
      font-size: 36px;
    }
  }
`
const BottomWrapper = styled.div`
  display: flex;
  flex-direction: column;
`
const BottomTitle = styled.div`
  background-color: #00fff0;
  width: 57%;
  height: 32px;
  border-radius: 4px 0 0 0;
  padding: 4px 12px;
  clip-path: polygon(0% 0%, calc(100% - 32px) 0%, 100% 100%, 0% 100%);
  color: #000;
  font-weight: 700;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin-top: -40px;
`

const BottomContent = styled.div`
  width: 100%;
  /* height: 120px; */
  border: 1px solid #00fff0;
  border-radius: 0 12px 12px 12px;
  padding: 30px;
  position: relative;
  background: linear-gradient(
    135deg,
    rgba(0, 255, 238, 0.264),
    rgba(0, 255, 238, 0)
  );
  p {
    font-size: 24px;
    color: #00fff0;
    font-weight: 700;
  }
  .title {
    position: absolute;
    top: 0;
  }
`
